import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "@vellum/micro-app-auth";
import "./index.css";
import { router } from "./router";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element #root not found");
}

// `AuthProvider` already wraps its children in `FeatureFlagProvider` using the
// same fetcher, so `useFeatureFlag` works without one here. Nesting a second
// provider would fetch /flags/me twice on every load.
createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
